module.exports = __webpack_public_path__ + "static/media/import.211dc564.png";